export const OFFER_CATEGORY = {
  Deals: 'deals',
  DealsEducation: 'deals_education',
  DealsEntertainment: 'deals_entertainment',
  DealsFinance: 'deals_finance',
  DealsFood: 'deals_food',
  DealsHealth: 'deals_health',
  DealsLifestyle: 'deals_lifestyle',
  DealsShopping: 'deals_shopping',
  DealsTravel: 'deals_travel',
  DealsUtilities: 'deals_utilities',
  Games: 'games',
  GamesAction: 'games_action',
  GamesAdventure: 'games_adventure',
  GamesArcade: 'games_arcade',
  GamesBoard: 'games_board',
  GamesCard: 'games_card',
  GamesCasino: 'games_casino',
  GamesCasual: 'games_casual',
  GamesFamily: 'games_family',
  GamesMusic: 'games_music',
  GamesPuzzle: 'games_puzzle',
  GamesRacing: 'games_racing',
  GamesRpg: 'games_rpg',
  GamesSimulation: 'games_simulation',
  GamesSports: 'games_sports',
  GamesStrategy: 'games_strategy',
  GamesTrivia: 'games_trivia',
  GamesWord: 'games_word',
} as const;

export const BLACKLISTED_OFFER_CATEGORY = 'Blacklisted';

// Canonical game categories are managed in the database, so their values are
// dynamic. The constants below remain the stable values for broad offer types
// and the existing deal taxonomy.
export type OfferCategory = string;
export type OfferCategoryGroup = 'Deals' | 'Games';

export interface OfferCategoryDefinition {
  value: OfferCategory;
  label: string;
  group: OfferCategoryGroup;
}

export const OFFER_CATEGORY_DEFINITIONS: readonly OfferCategoryDefinition[] = [
  { value: OFFER_CATEGORY.Deals, label: 'Deals', group: 'Deals' },
  { value: OFFER_CATEGORY.DealsEducation, label: 'Education', group: 'Deals' },
  { value: OFFER_CATEGORY.DealsEntertainment, label: 'Entertainment', group: 'Deals' },
  { value: OFFER_CATEGORY.DealsFinance, label: 'Finance', group: 'Deals' },
  { value: OFFER_CATEGORY.DealsFood, label: 'Food', group: 'Deals' },
  { value: OFFER_CATEGORY.DealsHealth, label: 'Health', group: 'Deals' },
  { value: OFFER_CATEGORY.DealsLifestyle, label: 'Lifestyle', group: 'Deals' },
  { value: OFFER_CATEGORY.DealsShopping, label: 'Shopping', group: 'Deals' },
  { value: OFFER_CATEGORY.DealsTravel, label: 'Travel', group: 'Deals' },
  { value: OFFER_CATEGORY.DealsUtilities, label: 'Utilities', group: 'Deals' },
  { value: OFFER_CATEGORY.Games, label: 'Games', group: 'Games' },
  { value: OFFER_CATEGORY.GamesAction, label: 'Action', group: 'Games' },
  { value: OFFER_CATEGORY.GamesAdventure, label: 'Adventure', group: 'Games' },
  { value: OFFER_CATEGORY.GamesArcade, label: 'Arcade', group: 'Games' },
  { value: OFFER_CATEGORY.GamesBoard, label: 'Board', group: 'Games' },
  { value: OFFER_CATEGORY.GamesCard, label: 'Card', group: 'Games' },
  { value: OFFER_CATEGORY.GamesCasino, label: 'Casino', group: 'Games' },
  { value: OFFER_CATEGORY.GamesCasual, label: 'Casual', group: 'Games' },
  { value: OFFER_CATEGORY.GamesFamily, label: 'Family', group: 'Games' },
  { value: OFFER_CATEGORY.GamesMusic, label: 'Music', group: 'Games' },
  { value: OFFER_CATEGORY.GamesPuzzle, label: 'Puzzle', group: 'Games' },
  { value: OFFER_CATEGORY.GamesRacing, label: 'Racing', group: 'Games' },
  { value: OFFER_CATEGORY.GamesRpg, label: 'RPG', group: 'Games' },
  { value: OFFER_CATEGORY.GamesSimulation, label: 'Simulation', group: 'Games' },
  { value: OFFER_CATEGORY.GamesSports, label: 'Sports', group: 'Games' },
  { value: OFFER_CATEGORY.GamesStrategy, label: 'Strategy', group: 'Games' },
  { value: OFFER_CATEGORY.GamesTrivia, label: 'Trivia', group: 'Games' },
  { value: OFFER_CATEGORY.GamesWord, label: 'Word', group: 'Games' },
];
